document.addEventListener('DOMContentLoaded', function () {
    var siteHeader = document.querySelector('.site-header');

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 100) {
            if (prevScrollpos > currentScrollPos) {
                siteHeader.classList.remove('site-header-off');
            } else {
                siteHeader.classList.add('site-header-off');
            }
            prevScrollpos = currentScrollPos;
        } else {
            siteHeader.classList.remove('site-header-off');
        }
    }
});